"use client";

import type { PreviewComponentProps } from "../types";
import { previewRegistry } from "../registry/PreviewRegistry";

export type PreviewAdapterProps = PreviewComponentProps;

/**
 * Resolves and renders the preview component for its type. Returns null when no component is registered.
 * Does not run registration — `LayoutWrapper` calls `initializePreviewRegistry()` once at module load.
 */
export const PreviewAdapter = (props: PreviewAdapterProps) => {
  const Preview = previewRegistry.get(props.type);

  if (!Preview) {
    return null;
  }

  return <Preview {...props} />;
};
